module.exports = __webpack_public_path__ + "img/icon-menu.0be1a677.svg";